import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Button, Grid, Popup, Input, Segment, Icon, Dropdown} from 'semantic-ui-react';
import DatePicker from "react-datepicker"
import moment from "moment";
import debounce from "lodash.debounce";
import './../../../styles/global.scss';

const regex = new RegExp('[A-Za-z0-9 _.,!$]*');

export class MultiDateFilter extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            filter: this.props.filter || "",
            fromDate: this.props.fromDate || moment().subtract(12, "months").toDate(),
            toDate: this.props.toDate || moment().toDate(),
            multiFromDate: this.props.multiFromDate ,
            multiToDate: this.props.multiToDate ,
            filterValid: true,
            advancedFilters : this.props.advancedFilters,
            initialAdvancedFilters: this.props.advancedFilters,
            advancedFilterSelections: {
          
             }
        , // Initialize an empty object for selections
        };

        this.debouncedSubmit = debounce(this.props.onSubmitFilter, this.props.interval || 500);
    }

    

    componentDidMount()
    {

    }

    componentDidUpdate(prevProps)
    {

        if (prevProps.filterValue !== this.props.filterValue) {
            this.setState({
                filter: this.props.filterValue
            }, () => {
                // Optionally: Do something after state update
                this.raiseChange()
            });
        }

      if (this.props.statusOverride !== prevProps.statusOverride) {
        if (this.props.statusOverride == null) {
            // If statusOverride is explicitly null, reset advancedFilterSelections
            this.setState({
                advancedFilterSelections: {}
            });
        } else {
            // If statusOverride is not null, proceed with setting it
            this.setState({
                advancedFilterSelections: {
                    ...this.state.advancedFilterSelections,
                    'Status': [this.props.statusOverride.toLowerCase()]
                }
            });
        }
        }

        if (this.props.queryTypeOverride !== prevProps.queryTypeOverride) {

          
            this.setState({
                advancedFilterSelections: {
                    ...this.state.advancedFilterSelections,
                    'QueryType': [this.props.queryTypeOverride.toLowerCase()]
                }
            });
        }


        if(this.props.initialDate !== prevProps.initialDate)
        {
            const initialToDate = this.props.initialDate ? moment(this.props.initialDate, "YYYY-MM-DD").toDate() : moment().subtract(12, "months").toDate();
            const initialFromDate = this.props.initialDate ? moment(this.props.initialDate, "YYYY-MM-DD").add(-1, "month").toDate() : moment().toDate();
        
            this.fromDateChanged(initialFromDate)
            this.toDateChanged(initialToDate)

        }
        

      if(this.state.filter === "" && this.props.filter !== "" && this.state.loadedSave === false)
      {
       
        this.setState({
          filter : this.props.filter,
          filterValid : true,
          loadedSave : true,
          advancedFilters : this.props.advancedFilters
        })
  
        this.debouncedSubmit({ filter: this.props.filter });
      } else
  
      {
        if(!this.state.advancedFilters && this.props.advancedFilters)
        {
        this.setState({
          advancedFilters : this.props.advancedFilters
        })
      }
      }
    }

    handleChangeDropDown = (_p, {name, value }) => {


        this.setState(prevState => ({
            advancedFilterSelections: {
                ...prevState.advancedFilterSelections,
                [name]: value, // Update the selection for this filter
            }
        }));

        this.props.onAdvancedFilterChange({name, value })
    
      };

    handleOnChange = (event, {name, value}) => {
        if (value !== '' && !regex.test(value)) {
            this.setState({[name]: value, filterValid: false});
        } else {
            this.setState({[name]: value, filterValid: true}, this.raiseChange);
        }
    };

    clearFilters = () => {
        const resetState = {
            // Define the structure of the reset state based on how onAdvancedFilterChange expects it
            // This might include resetting to default values or empty states depending on your filters' structure
        };

        this.setState({
            filter: "",
            fromDate: moment().subtract(12, "months").toDate(),
            toDate: moment().toDate(),
            multiFromDate: null, // Or set to your default
            multiToDate: null, // Or set to your default
            advancedFilters: this.state.initialAdvancedFilters,
            advancedFilterSelections: {}, // Reset advanced filter selections
            // Reset any other filter-related states here
        }, () => {
            // After state update, you might want to submit the cleared filters
            this.raiseChange();
            this.props.onAdvancedFilterChange({resetState})

        });
    };
    

    fromDateChanged = (newDate) => {
        this.setState({ fromDate: newDate || null }, this.raiseChange); // Reset to null if cleared
    }

    toDateChanged = (newDate) => {
        this.setState({ toDate: newDate || null }, this.raiseChange); // Reset to null if cleared
    }

    multiFromDateChanged = (newDate) => {
        this.setState({ multiFromDate: newDate || null }, this.raiseChange); // Reset to null if cleared
    }

    multiToDateChanged = (newDate) => {
        this.setState({ multiToDate: newDate || null }, this.raiseChange); // Reset to null if cleared
    }

    raiseChange = () => {
        this.debouncedSubmit({filter: this.state.filter, fromDate: this.state.fromDate, toDate: this.state.toDate, multiFromDate : this.state.multiFromDate, multiToDate : this.state.multiToDate});
    }

    render() {
        const { filter } = this.state;
        let popupMessage = '';
        if (!this.state.filterValid) {
            popupMessage = 'Invalid character.';
        } else if (this.props.totalCount === 0) {
            popupMessage = 'No results found.';
        }
    
        const CustomInput = ({ value, onClick }) => (
            <Input fluid icon="calendar" iconPosition='left' value={value} onClick={onClick}      className="customDatePickerInput"  />
        );

        


const tooltipContent = (
    <div>
      <p>Use this filter to search across various case attributes including:</p>
      <ul>
        <li><strong>Case Number</strong></li>
        <li>Description of the query</li>
        <li>Case Type or Category</li>
        <li>Current Status of the case</li>
        <li>Site-related information such as Address, Site Name, or Site Number</li>
        <li>Meter Site Address for cases logged against specific meters</li>
      </ul>
      <p>Type your search term to find cases by any of the above attributes.</p>
    </div>
  );

        
        return (
            <Grid padded stackable>
                            <Grid.Row columns={1}>
                <Grid.Column textAlign="right">
                    <Button 
                        icon="remove" 
                        content="Clear All Filters" 
                        onClick={this.clearFilters} 
                        basic 
                    />
                </Grid.Column>
            </Grid.Row>
                <Grid.Row columns={1}>
                    <Grid.Column>
                        <Popup
                            trigger={
                                <Fragment>
                                    <h4>Filter <Popup
    trigger={<Icon name="question circle outline" style={{ fontSize: '16px', marginRight: '5px' }} />}
    content={tooltipContent}
    position="top left"
/></h4>
                                    <Input
                                        fluid
                                        placeholder="Enter the filter."
                                        name="filter"
                                        value={filter}
                                        error={!this.state.filterValid}
                                        onChange={this.handleOnChange}
                                        icon="search"
                                        disabled={this.props.disabled}
                                    />
                                </Fragment>
                            }
                            content={popupMessage}
                            on="click"
                            open={!this.state.filterValid || this.props.totalCount === 0}
                            position="right center"
                        />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={4}>
                    <Grid.Column >
                        <h4>{this.props.fromDateLabel ? this.props.fromDateLabel : 'From Date'}</h4>
                        <DatePicker  selected={this.state.fromDate} locale="en-GB" isClearable dateFormat="dd/MM/yyyy" onChange={this.fromDateChanged}      customInput={<CustomInput />} disabled={this.props.disabled}   popperPlacement="bottom-start"  />
                    </Grid.Column>
                    <Grid.Column>
                        <h4>{this.props.toDateLabel ? this.props.toDateLabel : 'To Date'}</h4>
                        <DatePicker selected={this.state.toDate} locale="en-GB" isClearable dateFormat="dd/MM/yyyy" onChange={this.toDateChanged} customInput={<CustomInput />} disabled={this.props.disabled}    popperPlacement="bottom-start"  />
                    </Grid.Column>
                    <Grid.Column>
                        <h4>{this.props.multiFromDateLabel ? this.props.multiFromDateLabel : 'From Date'}</h4>
                        <DatePicker selected={this.state.multiFromDate} locale="en-GB" isClearable dateFormat="dd/MM/yyyy" onChange={this.multiFromDateChanged} customInput={<CustomInput />} disabled={this.props.disabled}    popperPlacement="bottom-start"  />
                    </Grid.Column>
                    <Grid.Column>
                        <h4>{this.props.multiToDateLabel ? this.props.multiToDateLabel : 'To Date'}</h4>
                        <DatePicker selected={this.state.multiToDate} locale="en-GB" isClearable dateFormat="dd/MM/yyyy" onChange={this.multiToDateChanged} customInput={<CustomInput />} disabled={this.props.disabled}    popperPlacement="bottom-start"  />
                    </Grid.Column>
                </Grid.Row>
                {this.state.advancedFilters && this.state.advancedFilters.length > 0 && (
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment.Group horizontal>
                                {this.state.advancedFilters.map((el) => {
                                    let options = [...el.filterValues];
                                  
                                    return (
                                        <Segment key={el.filterName}>
                                            <h4>
                                                {el.filterName === 'HHDataType' ? 'AMR/HH' : el.filterName.replace(/([A-Z])/g, ' $1').trim()}
                                            </h4>
                                            <Dropdown
                                                key={this.state.advancedFilterSelections[el.filterName] ? 'selected' : 'not-selected'} // Force re-render
                                                name={el.filterName}
                                                placeholder={el.filterName}
                                                multiple
                                                fluid
                                                selection
                                                options={options}
                                                value={this.state.advancedFilterSelections[el.filterName] || []} // Use state-controlled value
                                                onChange={this.handleChangeDropDown}
                                            />
                                        </Segment>
                                    );
                                })}
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                )}
            </Grid>
        );
    }
    
}

MultiDateFilter.propTypes = {
    onSubmitFilter: PropTypes.func.isRequired,
    onAdvancedFilterChange : PropTypes.func,
    interval: PropTypes.number,
    filter: PropTypes.string,
    disabled: PropTypes.bool,
    totalCount: PropTypes.number.isRequired,
    statusOverride : PropTypes.string,
    queryTypeOverride : PropTypes.string

};
